import React from "react";
import { useParams } from "react-router-dom";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import JobsPortalNeo from "../../pages/JobsPortalNeo";

const JobDetails = () => {
  const params = useParams();

  return (
    <>
      <Header />
      <JobsPortalNeo />
      <Footer />
    </>
  );
};

export default JobDetails;
